<template>
  <div class="vertical-calendar-container calendar-scroll-target vertical">
    <div class="verticalcalendar f7">
      <div class="timeincrement" v-for="time in times" :key="time">
        <div class="time">
          {{ time }}
        </div>
        <div class="lineverticalgroup" :class="{ '-maintenance': station.maintenanceModeEnabled }">
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>
      <div class="nowline" v-if="today" :style="{ transform: 'translateY(calc(672rem * ' + percentThroughDay + ')' }"></div>
      <booking-card v-for="booking of bookings" @click.native="goToMobileBookingDetail(booking.id)" :isNetworkAvailable="isNetworkAvailable" :twentyFourHourTime="location.twentyFourHourTime" :vertical="true" :key="booking.id" :calendarDate="calendarDate" :booking="booking" :stationId="station.id" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import OverviewHelper from '@/location/overview/OverviewHelper';
import DateHelper from '@/core/shared/helpers/DateHelper';
import BookingCard from '@/location/overview/calendar/BookingCard';
import moment from 'moment-timezone';

@Component({
  props: {
    times: {
      type: Array,
      required: true,
    },
    bookings: {
      type: Array,
      required: true,
    },
    station: {
      type: Object,
      required: true,
    },
    calendarDate: {
      type: String,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    isNetworkAvailable: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    BookingCard,
  },
})
export default class VerticalCalendar extends Vue {
  get today () {
    return DateHelper.dateMatch(this.currentTime, this.calendarDate);
  }

  get percentThroughDay () {
    return OverviewHelper.timeToPercentThroughDay(moment(this.currentTime));
  }

  mounted () {
    OverviewHelper.scrollToTime(this.currentTime);
  }

  goToMobileBookingDetail (bookingId) {
    this.$router.push({
      name: 'mobile-booking-detail',
      params: {
        stationId: this.station.id,
        bookingId,
      },
    });
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.vertical-calendar-container {
  flex: 0 0 100vh;
  z-index: 1;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.verticalcalendar {
  display: flex;
  flex-direction: column;
  background-color: var(--colorCasper);
  position: relative;

  & .timeincrement {
    display: flex;

    & .time {
      flex: 0 0 7rem;
      margin: 0;
      padding: 0;
      text-align: center;
      transform: translateY(-0.7rem);
    }

    & .lineverticalgroup {
      flex: 1 1 auto;

      & .line {
        border-bottom: 0.1rem solid rgb(209, 209, 209);
        /* border-bottom: 0.1rem solid color-mod(var(--colorCasper) blackness(20%)); */
        background-color: var(--colorCasper);
        width: 100%;
        height: 7rem;
      }
    }

    & .lineverticalgroup.-maintenance {
      & .line {
        background-color: rgb(165, 165, 165);
        border-left: 0.1rem solid rgb(136, 136, 136);
        /* background-color: color-mod(var(--colorCasper) blackness(50%)); */
        /* border-left: 0.1rem solid color-mod(var(--colorCasper) blackness(80%)); */
      }
    }
  }

  & .booking-card {
    left: 8rem !important;
  }

  & .nowline {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 0.3rem;
    background: linear-gradient(75deg, #f24847 0%, #f29d47 100%);
    z-index: 1;
    mix-blend-mode: multiply;
  }
}
</style>
